'use client';

import { useState, useEffect } from 'react';
import { cn } from '~/lib/utils';
import Image from 'next/image';

export function FixedScrollTop() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const isPC = window.innerWidth > 768; // PCの判定
      const threshold = isPC ? 800 : 320; // PCとSPの閾値

      if (scrollY > threshold) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className={cn(
        'fixed bottom-20 right-10 z-10 transition-opacity duration-300 hidden md:block',
        isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none',
      )}
    >
      <a className="js-back-to-top" href="#">
        <Image
          src="/nextjs/images/buttons/btn_back_to_top.svg"
          alt="スクロールトップ"
          width={85}
          height={65}
          className="h-[65px]"
        />
      </a>
    </div>
  );
}
